/**
 * Метка «сессия протухла» между перезагрузками страницы.
 * Ставится там, где токены отзываются (401 без возможности обновиться), и
 * читается при старте — лендинг покажет форму входа с сообщением.
 */
const KEY = "rl.session-expired";

export function markSessionExpired(): void {
    try {
        sessionStorage.setItem(KEY, "1");
    } catch {
        // Приватный режим — просто не покажем сообщение.
    }
}

/** Прочитать и снять метку: сообщение показывается один раз. */
export function consumeSessionExpired(): boolean {
    try {
        const value = sessionStorage.getItem(KEY);
        if (value) sessionStorage.removeItem(KEY);
        return Boolean(value);
    } catch {
        return false;
    }
}
